.attrWrapper {
  display: flex;
  flex: 1;
  align-items: stretch;
  justify-content: center;
}

.attrWrapper + .attrWrapper {
  border-left: 1px solid var(--ib-line-2);
}

.touchable {
  width: 100%;
  padding: 10px 4px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  letter-spacing: 0.03em;
}

.touchable:hover {
  background: var(--ib-line-2) !important;
  border: 0 !important;
  text-decoration: none !important;
}

.touchable:hover span {
  color: var(--ib-red) !important;
}
